import { render, staticRenderFns } from "./RegisteredThanks.vue?vue&type=template&id=39d25991&scoped=true&"
import script from "./RegisteredThanks.vue?vue&type=script&lang=js&"
export * from "./RegisteredThanks.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredThanks.vue?vue&type=style&index=0&id=39d25991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d25991",
  null
  
)

export default component.exports